export enum CustomWalletExternalUrl {
  OKTO_WALLET = "https://okto.tech",
}
